import { Image, ImageProps } from "expo-image";
import React from "react";

import defaultImage from "@/assets/icons/placeholder.png";

type ExternalImageProps = {
  width: string | number;
  height: string | number;
  borderRadius?: number;
  opacity?: number;
} & ImageProps;

const ExternalImage = ({ width, height, borderRadius, opacity, ...props }: ExternalImageProps) => {
  return (
    <Image
      placeholder={defaultImage}
      style={{
        width,
        height,
        borderRadius: borderRadius || 0,
        opacity: opacity || 1,
      }}
      {...props}
    />
  );
};

export default ExternalImage;
